import { useCallback } from 'react';
import { useAuthStore } from '../auth/store';
import { useCmsStore } from '../cms/store';
import { useDataBoxStore } from '../data-box/store';
import { useFiltersStore } from '../filters/store';
import { usePersonStore } from '../person/store';

export const useAppLogout = () => {
	const dataBoxReset = useDataBoxStore('dataBoxReset');
	const personReset = usePersonStore('personReset');
	const resetCms = useCmsStore('resetCms');
	const filtersResetAction = useFiltersStore('filtersResetAction');
	const logoutAction = useAuthStore('logout');

	const logout = useCallback(() => {
		logoutAction();

		dataBoxReset();
		personReset();
		resetCms();
		filtersResetAction();
	}, [logoutAction, dataBoxReset, personReset, resetCms, filtersResetAction]);

	return { logout };
};
